import classNames from 'classnames';

import './SchemaCell.scss';
interface IProps {
  sign: string;
  count?: number;
  onClick?: () => void;
  selected?: boolean;
  completed?: boolean;
}
export const SchemaCell = ({count = 1, sign, onClick, selected, completed}: IProps) => {

  return (
    <div className={classNames('schema-cell', {selected, completed})} onClick={onClick}>
      <div className={classNames("img", sign)}/>
      <div className="schema-cell_count">{count}</div>
    </div>
  )
}
